@if (showText) {
  <span>Laddar</span>
}
@if (isLoading) {
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
}
